const steps = [
  { num: 1, title: 'Browse Product Spreadsheet', desc: 'Access the curated product catalog organized in itaobuy spreadsheet format with thousands of items across 14 categories.' },
  { num: 2, title: 'Select Product Links', desc: 'Pick the items you want by copying product links directly from the spreadsheet into your order list.' },
  { num: 3, title: 'Submit Order Request', desc: 'Send your compiled order through the itaobuy sheet system for instant processing by the sourcing team.' },
  { num: 4, title: 'Agent Processes Purchase', desc: 'A dedicated agent verifies availability, negotiates pricing, and completes the purchase on your behalf.' },
  { num: 5, title: 'Warehouse Consolidation', desc: 'All your items arrive at the consolidation warehouse where they are inspected, photographed, and packaged together.' },
  { num: 6, title: 'International Shipping', desc: 'Your consolidated package ships worldwide with tracking, insurance, and full visibility through the spreadsheet.' },
];

export default function HowItWorks() {
  return (
    <section className="py-16 md:py-20 px-6 md:px-10 bg-background-100/60">
      <div className="max-w-[1200px] mx-auto">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-900 mb-3">
            How Itaobuy Spreadsheet Works
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-[600px] mx-auto leading-relaxed">
            A simple six-step process that transforms complex sourcing into a streamlined, transparent workflow.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {steps.map((step) => (
            <div
              key={step.num}
              className="group flex gap-4 p-5 rounded-xl bg-background-50 hover:bg-background-100 transition-colors duration-200"
            >
              <div className="flex-shrink-0 w-10 h-10 rounded-full bg-accent-100 flex items-center justify-center">
                <span className="text-accent-700 font-bold text-sm">{step.num}</span>
              </div>
              <div>
                <h4 className="text-foreground-900 font-semibold text-sm mb-1.5">
                  {step.title}
                </h4>
                <p className="text-foreground-500 text-xs leading-relaxed">
                  {step.desc}
                </p>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-12 text-center">
          <p className="text-foreground-500 text-sm mb-4">
            The entire process is tracked and managed through the itaobuy spreadsheet
          </p>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-primary-500 text-background-50 text-sm font-semibold cursor-pointer hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap"
          >
            Start Using Itaobuy Spreadsheet
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line"></i>
            </span>
          </a>
        </div>
      </div>
    </section>
  );
}